export default __webpack_public_path__ + "static/pic_testimonials--red-b118d7944039f6382d494472213995e8.svg";